import styled from 'styled-components'

// Botao primario sobre o bege: superficie ESCURA, como o card
// (DESIGN.md > Componentes). A 11.18:1 do fundo ja le como acao principal.
export const Container = styled.button`
  width: 90%;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.surface};
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.surfaceText};
  margin-top: 12px;
  margin-bottom: 8px;
  transition: background-color 0.2s;

  &:active {
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
  }
`;
